import React from "react";
import moment from "moment";
import "./Itenary.css";

function Itenary({ operator, segments, startTime, endTime }) {
  const duration = moment.duration(endTime.diff(startTime));
  const hours = parseInt(duration.asHours());
  const minutes = parseInt(duration.asMinutes()) % 60;

  const connectingFlights = (layover, index) => {
    return (
      <div className="p-3 pt-0" key={index}>
        <div
          className="row flight-card p-2 p-md-2 "
          style={{ background: "transparent", border: "1px dashed #ccc" }}
        >
          <div className="col-12 col-md-2 text-center mt-2 text-small">
            <img
              className="mb-1"
              src={operator.logo}
              alt="logo"
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
                borderRadius: 30,
              }}
            />
            <div>{layover.airline}</div>
            <span className="text-muted">
              {layover.flightCode}-{layover.flightNumber}
            </span>
          </div>

          <div className="col-6 col-md-3 text-start mt-2">
            <h6 className="mb-0">
              {moment(layover.departureTime).format("HH:mm")}
            </h6>
            <h6 className="mb-0">{layover.departure.city}</h6>
            <p className="text-muted" style={{ fontSize: "0.8rem", margin: '0px' }}>
              {layover.departure.airport}
            </p>
            <p className="text-muted" style={{ fontSize: "0.8rem", margin: '0px' }}>
              Terminal - {layover.departure.terminal}
            </p>
          </div>

          <div className="col-12 col-md-4 mt-2 d-none d-md-block">
            <div
              className="text-center position-relative"
              style={{
                fontSize: "0.8rem",
                borderTop: "1px dashed #999",
                marginTop: 30,
              }}
            >
              <i
                className="fas fa-plane-departure me-2 position-absolute bg-light p-1 rounded-3"
                style={{ left: "0px", top: "-12px" }}
              />
              <i
                className="fas fa-plane-arrival me-2 position-absolute bg-light p-1 rounded-3"
                style={{ right: "-7px", top: "-12px" }}
              />
            </div>
          </div>

          <div className="col-6 col-md-3 text-end mt-2">
            <h6 className="mb-0">
              {moment(layover.arrivalTime).format("HH:mm")}
            </h6>
            <h6 className="mb-0">{layover.arrival.city}</h6>
            <p className="text-muted" style={{ fontSize: "0.8rem", margin: '0px' }}>
                 {layover.arrival.airport}
            </p>
            <p className="text-muted" style={{ fontSize: "0.8rem", margin: '0px' }}>
              Terminal - {layover.arrival.terminal}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="itenary-flight-container shadow-sm">
        <div className="itenary-flight-operator-section">
          <div className="itenary-flight-operator-logo-wrapper">
            <img
              alt="Airline_logo"
              className="itenary-flight-logo"
              src={operator.logo}
            />
            <div className="itenary-flight-operator-info">
              <p className="itenary-flight-operator-name">{operator.name}</p>
              <p className="itenary-flight-flight-code">
                {operator.code}-{operator.number}
              </p>
            </div>
          </div>
        </div>

        <div className="itenary-flight-details-section">
          <div className="itenary-flight-time-column itenary-flight-departure">
            <div className="itenary-flight-time-info">
              <p className="itenary-flight-time">
              {startTime.format("HH:mm")}
              </p>
              <p className="itenary-flight-city">
              {segments[0].departure.city}
              </p>
            </div>
            <div className="itenary-flight-ground-info">
              <p className="itenary-flight-airport">
              {segments[0].departure.airport}
              </p>
              <p className="itenary-flight-terminal">
                Terminal - {segments[0].departure.terminal}
              </p>
            </div>
          </div>

          <div className="itenary-flight-duration-column">
            <p className="itenary-flight-duration">
              {hours}h {minutes.toFixed(0)}m
            </p>
            <p className="itenary-flight-dash-line" />
            <p className="itenary-flight-stops">
              {segments.length > 1 ? `${segments.length - 1} Stop` : "Non-Stop"}
            </p>
          </div>

          <div className="itenary-flight-time-column itenary-flight-arrival">
            <div className="itenary-flight-time-info">
              <p className="itenary-flight-time">{endTime.format("HH:mm")}</p>
              <p className="itenary-flight-city">
                {segments[segments.length - 1].arrival.city}
              </p>
            </div>
            <div className="itenary-flight-ground-info">
              <p className="itenary-flight-airport">
                {segments[segments.length - 1].arrival.airport}
              </p>
              <p className="itenary-flight-terminal">
                Terminal - {segments[segments.length - 1].arrival.terminal}
              </p>
            </div>
          </div>
        </div>
      </div>

      {segments.length > 1 ? (
        <>
          <h6 className="w-100 d-flex flex-column align-items-center text-center text-small">
            <div
              style={{
                borderLeft: "1px dashed #ccc",
                height: "1rem",
                width: "1px",
              }}
            />
            <div className="mt-2 mb-2">
              <i className="fas fa-link"></i> {segments.length - 1} Connecting
              Flight
            </div>
            <div
              style={{
                borderLeft: "1px dashed #ccc",
                height: "1rem",
                width: "1px",
              }}
            />
          </h6>
          {segments.map(connectingFlights)}
        </>
      ) : undefined}
    </>
  );
}

export default Itenary;
